<template>
  <div class="SetupArea">
      <div class="item" @click="returnDetails">
          <i class="icon">
              <img src="~common/images/examination/icon-return.png" alt="返回详情">
          </i>
          <p>返回详情</p>
      </div>
     <div class="item">
        <el-popover placement="bottom-start" popper-class="proitem" trigger="hover">
            <div>
                <span class="text">字体大小</span>
                <el-button type="primary" :plain="setUpFontSizeData !== 18" @click="setUpFontSize(18)">大</el-button>
                <el-button type="primary" :plain="setUpFontSizeData !== 16" @click="setUpFontSize(16)">中</el-button>
                <el-button type="primary" :plain="setUpFontSizeData !== 14" @click="setUpFontSize(14)">小</el-button>
            </div>
            <div slot="reference">
                <i class="icon">
                    <img src="~common/images/examination/icon-font.png" alt="字体大小">
                </i>
                <p>字体大小</p>
            </div>
        </el-popover>
      </div>
      <div class="item" @click="stop" v-if="examstatus == 0">
          <i class="icon">
              <img src="~common/images/examination/icon-stop.png" alt="暂停考试">
          </i>
          <p>暂停考试</p>
      </div>
      <div class="item" v-else>
          <div class="switch">
              <el-switch v-model="seeWrongQuestionsData" @change="seeWrongQuestions"></el-switch>
          </div>
          <p>只看错题</p>
      </div>
  </div>
  <!-- end 设置区 -->
</template>

<script>
import $ from 'jquery'
import merge from 'webpack-merge'
export default {
  name: 'SetupArea',
  props: ['examend', 'examstatus'],   // 考试用时信息 提交状态
  data () {
    return {
      seeWrongQuestionsData: this.$route.query.status == '0' ? true : false,    // 只看错题
      setUpFontSizeData: 16, // 字体大小
      intervalTime: '',  // 时间计算器
      examinationTime: 0,   // 考试时间
      examinationTimeStatus: false,  // 考试计时状态 开启后只能赋值一次
    //   errorStatus: 
    }
  },
  mounted () {
  },
  methods: {
      setUpFontSize(fontsize) { // 设置字体大小
        this.setUpFontSizeData = fontsize
        // 清除原文本样式
        this._celarFontSize()
        switch (fontsize) {
            case 14:
                $('.answerarea-item').addClass('fontsize-14')
                break;
            case 16:
                $('.answerarea-item').addClass('fontsize-16')
                break;
            case 18:
                $('.answerarea-item').addClass('fontsize-18')
                break;
        }
      },
      returnDetails() { // 返回详情弹窗触发
        if (this.examstatus == 1) {
            // 试卷提交的情况下不触发弹窗直接返回详情页面
            this.$router.push({name: 'QuestionDetails', query: {qid: this.$route.query.bankid}})
        } else {
            this.$parent.startChildClickContinuePopu()
        }
      },
      stop() {  // 暂停考试
        // 开启点击继续弹窗
        this.$parent.startChildClickContinue()
        clearInterval(this.intervalTime)    // 关闭时间计算器
      },
      examinationTimeCalculation() {   // 考试时间计算
        // 已经提交试卷情况下不倒计时
        if (this.examstatus == 1) {
            // 进行时间格式转换 转换成 00:00:00
            let time = this._secondsFormat(this.examinationTime) // 时间秒转成 时:分：秒
            this.$parent.setChildExamTime(time)     
        } else {
            this.intervalTime = setInterval(() => {
                this.examinationTime --
                if(this.examinationTime <= 0) { //  倒计时为0时关闭时间播放器
                    clearInterval(this.intervalTime)
                    
                    // 自动提交试卷
                    // let viewingResults()
                    this.$parent.$refs.submitPapersPopu.viewingResults()

                } else {
                    // 进行时间格式转换 转换成 00:00:00
                    let time = this._secondsFormat(this.examinationTime) // 时间秒转成 时:分：秒
                    this.$parent.setChildExamTime(time)     
                }


            }, 1000)
        }
      },
      seeWrongQuestions() {
        // 修改当前页路由
        this.$router.push({
            query: merge(this.$route.query, {'page': 1, 'status': this.seeWrongQuestionsData == true?0:''})
        })
      },
      _secondsFormat(s) {  //将考试时间秒转成 时:分：秒
        let hour = this._zeroCompensation(Math.floor(s/3600), 2),
        minute = this._zeroCompensation(Math.floor((s - hour * 3600) / 60), 2),
        second = this._zeroCompensation(s - hour * 3600 - minute * 60, 2)
        return hour + ":" + minute + ":" +second
      },
      _zeroCompensation(num, length) { // 补零
        return (Array(length).join('0') + num).slice(-length)
      },
      _celarFontSize() {    // 清除文本样式
        $(".answerarea-item").removeClass("fontsize-14")
        $(".answerarea-item").removeClass("fontsize-16")
        $(".answerarea-item").removeClass("fontsize-18")
      }
  },
  filters: {},
  watch: {
      'examend': {
          handler(type) {
            // 考试时间计算
            if (type.isastrict == 1) {
                if (this.examinationTimeStatus == false) {
                    this.examinationTimeStatus = true
                    this.examinationTime = type.examendtime   // 距离考试结束时间
                    this.examinationTimeCalculation()
                }
            }
          } 
      }
  },
  computed: {},
  components: {}
}
</script>

<style lang="scss" type="text/scss" scope>
.SetupArea {
    height: 75px;
    background: #fff;
    
    .item {
        float: left;
        width: calc(100% / 3);
        text-align: center;
        cursor: pointer;
        p {
            margin-top: 5px;
            font-size: 14px;
            color: #303133;
        }
        img {
            display: block;
            margin: auto;
            margin-top: 12px;
            width: 30px;
            height: 30px;
        }

        
    }
    .switch {
        display: block;
        margin-top: 22px;
    }
}   
.proitem {
    .el-button {
        padding: 0;
        min-width: 22px;
        min-height: 22px;
        width: 22px;
        height: 22px;
    }
    .text {
        margin-right: 12px;
        font-size: 14px;
    }
}
</style>